import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { Form, Input, Button } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import UserAPI from '@/api/user';
import utils from '@/utils/auth';
import Logo from '../../images/logo.png';

const LoginContainer = styled.div`
  .form-wrapper {
    position: relative;
    width: 100%;
    height: 100vh;
    .login-form {
      position: absolute;
      top: 40%;
      left: 50%;
      width: 400px;
      margin: 0 auto;
      transform: translate(-50%, -50%);
      .top {
        margin: 0 auto 40px;
        .logo {
          display: block;
          width: 60px;
          margin: 0 auto 20px;
        }
        h4 {
          font-size: 24px;
          text-align: center;
        }
      }
    }
  }
`;
class LoginPage extends Component {

  onSubmit = values => {
    UserAPI.userLogin(values)
        .then(userInfo => {
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.props.history.push('/layout');
        });
  }

  render () {
    if (utils.isLoginStatus()) {
      return <Redirect to="/layout" />;
    }

    return (
        <LoginContainer>
          <div className="form-wrapper">
            <Form
                className="login-form"
                onFinish={this.onSubmit}
            >
              <div className="top">
                <img className="logo" src={Logo} alt="logo"/>
                <h4>仲正堂-美团预约管理后台</h4>
              </div>
              <Form.Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: '请输入账号',
                    },
                  ]}
                  required
              >
                <Input
                    prefix={<UserOutlined className="site-form-item-icon"/>}
                    placeholder="请输入账号"
                />
              </Form.Item>
              <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: '请输入密码',
                    },
                  ]}
                  required
              >
                <Input.Password
                    prefix={<LockOutlined className="site-form-item-icon"/>}
                    type="password"
                    placeholder="请输入密码"
                />
              </Form.Item>
              <Form.Item>
                <Button type="primary" block htmlType="submit">
                  登录
                </Button>
              </Form.Item>
            </Form>
          </div>
        </LoginContainer>
    );
  }
}

export default withRouter(LoginPage);
